/* eslint-disable react-refresh/only-export-components */
// 组件 + variants(buttonVariants)同文件为 shadcn/ui 有意模式;react-refresh 仅关注 HMR。
import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/shared/lib/utils";

const buttonVariants = cva(
  [
    "cyber-btn relative inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium",
    "ring-offset-background transition-all duration-300",
    "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
    "disabled:pointer-events-none disabled:opacity-50",
    "[&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
    "active:scale-[0.97]",
    "tracking-wide",
  ].join(" "),
  {
    variants: {
      // 配色走皮肤 token,3 套皮肤都正确区分;cyber 的霓虹渐变/辉光由 skin-cyber.css
      // 的通用 `:is(button,a).bg-primary` / `button.border-input` / `[class*="hover:bg-accent"]`
      // 等 !important 规则在 cyber 皮肤下还原(保留 cyber-btn-* 钩子类)。
      variant: {
        default:
          "cyber-btn-primary bg-primary text-primary-foreground hover:bg-primary/90 hover:-translate-y-[1px]",
        destructive:
          "cyber-btn-destructive bg-destructive text-destructive-foreground hover:bg-destructive/90 hover:-translate-y-[1px]",
        outline:
          "cyber-btn-outline border border-input bg-background text-foreground hover:bg-accent hover:text-accent-foreground",
        secondary:
          "cyber-btn-secondary bg-secondary text-secondary-foreground hover:bg-secondary/80",
        ghost: "cyber-btn-ghost text-foreground hover:bg-accent hover:text-accent-foreground",
        link: "cyber-btn-link text-primary underline-offset-4 hover:underline",
      },
      size: {
        default: "h-10 px-4 py-2",
        sm: "h-9 rounded-md px-3",
        lg: "h-11 rounded-md px-8",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  asChild?: boolean;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button";
    return (
      <Comp className={cn(buttonVariants({ variant, size, className }))} ref={ref} {...props} />
    );
  }
);
Button.displayName = "Button";

export { Button, buttonVariants };
